import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@env/environment';

@Component({
  selector: 'vc-product-authentication-modal',
  templateUrl: './product-authentication-modal.component.html',
  styleUrls: ['./product-authentication-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductAuthenticationModalComponent implements OnInit {
  free_autentication_for_instock = environment.feature.free_autentication_for_instock;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  ngOnInit() {}
}
